import { createdATFilter, getVisibleFilter, mainPhoneFilter } from 'modules/common/constants/filters/common.filters';
import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { addressFilters } from 'lib/dfl-address-filter';
import { EmptyFilter, OperatorFilter, TermFilter } from '@dofleini/query-builder';
import { SupplierService } from '../services';
import { SUPPLIER_LIST_CLEAN_KEY } from './supplier.queries';
import { transformWhitObjectId } from 'modules/common/constants/object-id';

export const commissionFilter: Filter = {
  filter: 'supplier:fields.commission',
  translate: true,
  type: FilterType.NUMBER,
  key: 'commission',
  field: 'commission',
};

export const supplierFilter: Filter = {
  filter: 'common:supplier',
  translate: true,
  type: FilterType.DYNAMIC_LIST,
  key: 'supplier',
  labelKey: 'name',
  field: 'supplier._id',
  fetchFunc: SupplierService.search,
  fetchOption: { size: 200 },
  queryKey: SUPPLIER_LIST_CLEAN_KEY,
  transform: (value) => transformWhitObjectId(value, 'supplier._id'),
};

const supplierAddressFilter = addressFilters({
  countryFilter: 'warehouse:address.country',
  countryKey: 'country',
  countryField: 'address.country',
  stateFilter: 'warehouse:address.state',
  stateKey: 'state',
  stateField: 'address.state',
  cityFilter: 'warehouse:address.city',
  cityKey: 'city',
  cityField: 'address.city',
});

const visibleFilter = getVisibleFilter('visible');

export const availabilityFilter: Filter = {
  filter: 'product:filterName.availability.title',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'stock',
  field: 'stock',
  transform: (value) => {
    if (Array.isArray(value)) return new EmptyFilter();
    switch (value) {
      case 'false':
        return new OperatorFilter({
          type: 'OR',
          filters: [
            new TermFilter({ field: 'stock.enable', value: false }),
            new TermFilter({ field: 'stock.enable', value: null }),
          ],
        }).toQuery();
      case 'true': {
        return new TermFilter({ field: 'stock.enable', value: true }).toQuery();
      }
    }
  },
  options: [
    {
      value: 'true',
      translate: true,
      label: 'product:filterName.availability.available',
    },
    {
      value: 'false',
      translate: true,
      label: 'product:filterName.availability.noAvailable',
    },
  ],
};

export const productOfferFilter: Filter = {
  filter: 'product:filterName.offer.title',
  translate: true,
  type: FilterType.FIXED_LIST,
  key: 'offer',
  field: 'scheduledOffers',
  transform: (value) => {
    if (Array.isArray(value)) return new EmptyFilter();

    return value === 'false'
      ? new EmptyFilter()
      : new TermFilter({ field: 'priceDetails.values.offer', value: { $ne: 0 } }).toQuery();
  },
  options: [
    {
      value: 'true',
      translate: true,
      label: 'product:filterName.offer.free',
    },
    {
      value: 'false',
      translate: true,
      label: 'product:filterName.offer.noFree',
    },
  ],
};

export const supplierFilters = [
  mainPhoneFilter,
  commissionFilter,
  ...supplierAddressFilter,
  visibleFilter,
  createdATFilter,
];

export const supplierConciliationFilters = [
  mainPhoneFilter,
  commissionFilter,
  ...supplierAddressFilter,
  createdATFilter,
];

// inventory/settings/suppliers/:id/sale_report
export const supplierReportFilters = [visibleFilter, availabilityFilter, productOfferFilter];
